// generated from 44 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const attributedCampaignFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("attributed_campaign_filter"),
  comparison_key: z.enum([
    "1", // 32 (72.73%)
    "10", // 10 (22.73%)
    "2", // 1 (2.27%)
    "11", // 1 (2.27%)
    "17",
  ]),
  display_name: z.string(),
  // undefined: 4 (9.09%), defined 40 (90.91%)
  raw_value: z.string().optional(),
  value: z.string(),
  varies_by_app_group: z.literal(true),
});
